import { addClasses, removeClasses, toggleClass } from './DOMHelpers';
import { IFrameHelper } from './IFrameHelper';
import { isExpandedView } from './settingsHelper';

// export const bubbleSVG =
//   'M240.808 240.808H122.123C56.6994 240.808 3.45695 187.562 3.45695 122.122C3.45695 56.7031 56.6994 3.45697 122.124 3.45697C187.566 3.45697 240.808 56.7031 240.808 122.122V240.808Z';

export const bubbleSVG =
  'M97.1947 22.137c-53.388 0-95.847 34.0929-95.847 78.1183 0 26.0098 17.8567 44.4828 33.5315 55.8032v35.8034c0 1.8248.918 3.5694 2.4746 4.5808l.0134.0133a5.4985 5.4985 0 0 0 2.9654.8723 5.478 5.478 0 0 0 2.2094-.468l.0137-.0132c1.101-.4909 19.5718-8.9909 36.041-26.5141 6.7907 1.2308 14.3125 2.4486 21.403 2.4486 26.9122 0 49.6158-7.1373 65.6852-19.8402 16.0696-12.7027 25.3902-31.0465 25.3902-52.7017 0-44.6302-40.7765-78.1028-93.8816-78.1028zm0 10.9172c47.72 0 82.9643 29.0111 82.9643 67.1894 0 18.4572-7.8734 33.6452-21.8071 44.4597-13.9334 10.8145-34.048 17.1745-58.3542 17.1745-6.9814 0-15.1848-1.3629-22.3112-2.7275h-.0396c-1.8582-.3361-3.7935.2819-5.0853 1.728v.0135c-9.5238 10.7416-19.8036 17.4912-26.7788 21.5817V153.332c0-1.7903-.889-3.4834-2.358-4.4933-14.4063-9.9145-31.169-26.3138-31.169-48.5844 0-37.4347 36.9238-67.2011 84.9455-67.2011zm106.8146 67.5655c-2.8274-.8665-5.9288.721-6.8265 3.56-.9012 2.8458.71 5.941 3.5468 6.8529h.0133c10.6643 3.3984 18.1272 7.5796 22.8416 12.6058 4.7142 5.0265 6.8782 10.8901 6.8782 18.5255 0 12.9041-12.371 23.7775-19.9914 29.0247-1.4673 1.0089-2.3712 2.682-2.3712 4.4933v17.0748c-3.777-1.8156-8.3385-4.484-12.8103-9.515v-.0132c-1.2888-1.4403-3.2334-2.0808-5.1112-1.728h-.0133c-1.7127.3334-3.3834.7816-5.0367 1.2251h-.0133c-2.8503.7696-5.602 1.4767-7.8856 1.4767-13.9701 0-23.2067-2.8533-33.0895-10.1225v-.0129c-2.4036-1.7612-5.867-1.2281-7.6339 1.16-1.7795 2.4063-1.2511 5.8726 1.1464 7.6478h.0133c11.7108 8.6124 23.5169 12.2407 39.5514 12.2407 3.977 0 7.5312-.9753 10.7265-1.8414h.0133c.5587-.1512 1.0694-.2772 1.6023-.4164 5.1135 5.043 10.428 8.4457 14.6382 10.4128 4.5355 2.1186 7.5114 2.7758 8.2413 2.9135h.025c.291.0573.6649.1135 1.0723.1135 1.2342 0 2.4548-.4102 3.4436-1.225a5.4497 5.4497 0 0 0 2.0187-4.2413v-22.451c14.1185-10.445 22.349-23.1358 22.349-36.22 0-9.9768-3.0723-18.574-9.3528-25.4815-6.28-6.907-15.5875-12.1089-27.9648-16.0539-.009-.003-.0164-.009-.0252-.0135z';
export const body = document.getElementsByTagName('body')[0];
export const widgetHolder = document.createElement('div');

export const bubbleHolder = document.createElement('div');
export const chatBubble = document.createElement('button');
export const closeBubble = document.createElement('button');
export const notificationBubble = document.createElement('span');

export const setBubbleText = bubbleText => {
  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.getElementById('woot-widget--expanded__text');
    textNode.innerText = bubbleText;
  }
};

export const createBubbleIcon = ({ className, path, target }) => {
  let bubbleClassName = `${className} woot-elements--${window.$chatwoot.position}`;
  const bubbleIcon = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'svg'
  );
  bubbleIcon.setAttributeNS(null, 'id', 'woot-widget-bubble-icon');
  bubbleIcon.setAttributeNS(null, 'width', '24');
  bubbleIcon.setAttributeNS(null, 'height', '24');
  bubbleIcon.setAttributeNS(null, 'viewBox', '0 0 240 240');
  bubbleIcon.setAttributeNS(null, 'fill', 'none');
  bubbleIcon.setAttribute('xmlns', 'http://www.w3.org/2000/svg');

  const bubblePath = document.createElementNS(
    'http://www.w3.org/2000/svg',
    'path'
  );
  bubblePath.setAttributeNS(null, 'd', path);
  bubblePath.setAttributeNS(null, 'fill', '#FFFFFF');

  bubbleIcon.appendChild(bubblePath);
  target.appendChild(bubbleIcon);

  if (isExpandedView(window.$chatwoot.type)) {
    const textNode = document.createElement('div');
    textNode.id = 'woot-widget--expanded__text';
    textNode.innerText = '';
    target.appendChild(textNode);
    bubbleClassName += ' woot-widget--expanded';
  }

  target.className = bubbleClassName;
  target.title = 'Open chat window';
  return target;
};

export const createBubbleHolder = hideMessageBubble => {
  if (hideMessageBubble) {
    addClasses(bubbleHolder, 'woot-hidden');
  }
  addClasses(bubbleHolder, 'woot--bubble-holder');
  body.appendChild(bubbleHolder);
};

export const createNotificationBubble = () => {
  addClasses(notificationBubble, 'woot--notification');
  return notificationBubble;
};

export const onBubbleClick = (props = {}) => {
  const { toggleValue } = props;
  const { isOpen } = window.$chatwoot;
  if (isOpen !== toggleValue) {
    const newIsOpen = toggleValue === undefined ? !isOpen : toggleValue;
    window.$chatwoot.isOpen = newIsOpen;

    toggleClass(chatBubble, 'woot--hide');
    toggleClass(closeBubble, 'woot--hide');
    toggleClass(widgetHolder, 'woot--hide');
    IFrameHelper.events.onBubbleToggle(newIsOpen);

    if (!newIsOpen) {
      chatBubble.focus();
    }
  }
};

export const onClickChatBubble = () => {
  bubbleHolder.addEventListener('click', onBubbleClick);
};

export const addUnreadClass = () => {
  const holderEl = document.querySelector('.woot-widget-holder');
  addClasses(holderEl, 'has-unread-view');
};

export const removeUnreadClass = () => {
  const holderEl = document.querySelector('.woot-widget-holder');
  removeClasses(holderEl, 'has-unread-view');
};
